import { useCallback } from 'react';

import { setIsSignedOutManually } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useSignOut } from 'modules/auth/hooks/useSignOut';

export const useSignOutHandler = () => {
  const { handleSignOut } = useSignOut();

  const dispatch = useAppDispatch();

  const signOut = useCallback(() => {
    dispatch(setIsSignedOutManually(true));

    handleSignOut();
  }, [dispatch, handleSignOut]);

  return { signOut };
};
